import { Node } from 'tiptap'
import HotText from '@/components/tiptap/extensions/HotText'
export default class QuestionNode extends Node {
    get name () {
        return 'hot_text_node'
    }
    get schema () {
        return {
            attrs: {
                hot_text_id: {
                    default: null,
                },
                selected_text: {
                    default: false
                },
                hot_text_class: {
                    default: 'hot_text'
                },
                correct: {
                    default: false
                },
                style: {
                    default: "backround-color: 'pink'"
                }
            },
            group: 'inline',
            inline: true,
            selectable: false,
            isolating: false,
            draggable: true,
            parseDOM: [{
                tag: 'hot_text',
                getAttrs: dom => ({
                    hot_text_id: dom.getAttribute('hot_text_id'),
                    selected_text: dom.getAttribute('selected_text'),
                    hot_text_class: dom.getAttribute('hot_text_class'),
                    correct: dom.getAttribute('correct'),
                    style: dom.getAttribute('style')
                }),
            }],
            toDOM: node => ['hot_text', {
                hot_text_id: (node.attrs && node.attrs.hot_text_id) ? node.attrs.hot_text_id : null,
                selected_text: (node.attrs && node.attrs.selected_text) ? node.attrs.selected_text : null,
                hot_text_class: (node.attrs && node.attrs.hot_text_class) ? node.attrs.hot_text_class : null,
                correct: (node.attrs && node.attrs.correct) ? node.attrs.correct : null,
                style: (node.attrs && node.attrs.style) ? node.attrs.style : null,
            }],
        }
    }

    commands({ type }) {
        return (attrs) => (state, dispatch) => {
            dispatch(state.tr.replaceSelectionWith(
                type.create({
                    'hot_text_id': (attrs) ? attrs.hot_text_id : null,
                    'selected_text': (attrs) ? attrs.selected_text : null,
                    'hot_text_class': (attrs) ? attrs.hot_text_class : hot_text_class,
                    'correct': (attrs) ? attrs.correct : correct,
                    'style': (attrs) ? attrs.style : style,
                })
            ))
        }
    }

    get view () {
        return HotText
    }
}
